<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="container-fluid" *ngIf="accessService.hasAccess([], ['event_groups.menu'])">
  <div class="row align-items-center">
    <div class="col-auto">
      <h5 class="title-secondary">{{ 'EVENT_GROUPS.EVENT_GROUPS_LIST.TITLE' | translate }}</h5>
    </div>
    <div class="col-auto ms-auto">
      <button type="button" class="btn btn-link btn-clear-filters" (click)="clearFilters()">
        {{ 'CLEAR_FILTERS' | translate }}
      </button>

      <button
        *ngIf="accessService.hasAccess([UserRoleType.LEAD_GENERATION], ['event_groups.store'])"
        type="button"
        class="btn btn-secondary"
        (click)="add()"
      >
        {{ 'EVENT_GROUPS.EVENT_GROUPS_LIST.ADD' | translate }}
      </button>
    </div>
  </div>
  <kendo-grid
    [data]="data"
    [pageSize]="eventGroupsResponse?.meta.per_page"
    [sortable]="true"
    [filterable]="true"
    [columnMenu]="true"
    [filter]="state?.filter"
    [sort]="state?.sort"
    [skip]="state?.skip"
    [pageable]="true"
    (dataStateChange)="loadData($event)"
    (columnVisibilityChange)="onVisibilityChange($event)"
    #grid
    (excelExport)="onExcelExport($event, 'Events_groups', grid)"
  >
    <kendo-grid-column
      [width]="70"
      class="text-center"
      headerClass="text-center"
      title="{{ 'EVENT_GROUPS.EVENT_GROUPS_LIST.NUMBER' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="id"
      title="{{ 'EVENT_GROUPS.EVENT_GROUPS_LIST.ID' | translate }}"
      filter="numeric"
      [width]="150"
      [hidden]="isHiddenColumn('id')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="name"
      title="{{ 'EVENT_GROUPS.EVENT_GROUPS_LIST.NAME' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('name')"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <a [routerLink]="['/event-groups/view']" [queryParams]="{ id: dataItem.id }" target="_blank">
          {{ dataItem.name }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="web_name"
      title="{{ 'EVENT_GROUPS.EVENT_GROUPS_LIST.WEB_NAME' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('web_name')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="venue.city.country.name"
      title="{{ 'EVENT_GROUPS.EVENT_GROUPS_LIST.COUNTRY' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('venue.city.country.name')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-country-select [filter]="filter" [field]="'venue.city.country_id'"></app-kendo-country-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-country-box [country]="dataItem?.venue?.city?.country"></app-country-box>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="venue.city.name"
      title="{{ 'EVENT_GROUPS.EVENT_GROUPS_LIST.CITY' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('venue.city.name')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-city-select [filter]="filter" [field]="'venue.city_id'"></app-kendo-city-select>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="priority.value"
      title="{{ 'EVENT_GROUPS.EVENT_GROUPS_LIST.PRIORITY' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('priority.value')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-type-select [groupType]="'event_group_priorities'" [filter]="filter" [field]="'priority_id'">
        </app-kendo-type-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-type-badge [type]="dataItem.priority"></app-type-badge>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="industry.name"
      title="{{ 'EVENT_GROUPS.EVENT_GROUPS_LIST.INDUSTRY' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('industry.name')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-industry-select [filter]="filter"></app-kendo-industry-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        <strong>{{ dataItem?.industry?.name }}</strong>
        <div *ngIf="dataItem?.industries?.length > 0">
          <span *ngFor="let industry of dataItem?.industries; let i = index">
            {{ industry.name }}<span *ngIf="i !== dataItem?.industries?.length - 1">, </span>
          </span>
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="tags"
      title="{{ 'EVENT_GROUPS.EVENT_GROUPS_LIST.TAGS' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('tags', true)"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <app-kendo-tag-select [filter]="filter" [model]="LaravelModels.EVENTGROUP"></app-kendo-tag-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <span *ngFor="let tag of dataItem?.tags; let i = index">
          {{ tag }}<span *ngIf="i !== dataItem?.tags?.length - 1">, </span>
        </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="repeat.value"
      title="{{ 'EVENT_GROUPS.EVENT_GROUPS_LIST.REPEAT' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('repeat.value')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-type-select [groupType]="'event_group_repeats'" [filter]="filter" [field]="'repeat_id'">
        </app-kendo-type-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-type-badge [type]="dataItem.repeat"></app-type-badge>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="founded_year"
      title="{{ 'EVENT_GROUPS.EVENT_GROUPS_LIST.FOUNDED_YEAR' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('founded_year')"
    ></kendo-grid-column>

    <!--    <kendo-grid-column-->
    <!--      field="created_at"-->
    <!--      title="{{ 'EVENT_GROUPS.EVENT_GROUPS_LIST.CREATED_AT' | translate }}"-->
    <!--      filter="date"-->
    <!--      [hidden]="isHiddenColumn('created_at')"-->
    <!--    >-->
    <!--      <ng-template kendoGridCellTemplate let-dataItem>-->
    <!--        {{ dataItem.created_at.getDate() }}-->
    <!--      </ng-template>-->
    <!--    </kendo-grid-column>-->

    <kendo-grid-column
      field="show_to_web"
      title="{{ 'EVENT_GROUPS.EVENT_GROUPS_LIST.SHOW_TO_WEB' | translate }}"
      filter="boolean"
      [width]="150"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('show_to_web')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.show_to_web"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="active"
      title="{{ 'EVENT_GROUPS.EVENT_GROUPS_LIST.ACTIVE' | translate }}"
      filter="boolean"
      [width]="150"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('active')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.active"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'EVENT_GROUPS.EVENT_GROUPS_LIST.ACTIONS' | translate }}"
      [width]="100"
      [class]="'text-center'"
      [includeInChooser]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER,
                UserRoleType.SALES_AGENT,
                UserRoleType.SALES_MANAGER,
                UserRoleType.CUSTOMER_CARE_AGENT,
                UserRoleType.CUSTOMER_CARE_MANAGER,
                UserRoleType.FINANCE_AGENT,
                UserRoleType.FINANCE_MANAGER,
                UserRoleType.LEAD_GENERATION,
                UserRoleType.IT,
                UserRoleType.MARKETING,
                UserRoleType.EXTERNAL_PARTNER_LEAD,
                UserRoleType.EXTERNAL_PARTNER
              ],
              ['events.index']
            )
          "
          (click)="pushToStorage(dataItem)"
          type="button"
          class="btn btn-warning btn-ico"
          [ngbTooltip]="'EVENT_GROUPS.EVENT_GROUPS_LIST.VIEW_ALL_FROM_EVENT_GROUP' | translate"
          container="body"
          [routerLink]="['/events']"
          [queryParams]="{ event_group_id: dataItem.id }"
        >
          <i class="fal fa-arrow-right"></i>
        </button>

        <app-preview-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER,
                UserRoleType.SALES_AGENT,
                UserRoleType.SALES_MANAGER,
                UserRoleType.CUSTOMER_CARE_AGENT,
                UserRoleType.CUSTOMER_CARE_MANAGER,
                UserRoleType.FINANCE_AGENT,
                UserRoleType.FINANCE_MANAGER,
                UserRoleType.LEAD_GENERATION,
                UserRoleType.IT,
                UserRoleType.MARKETING,
                UserRoleType.EXTERNAL_PARTNER_LEAD,
                UserRoleType.EXTERNAL_PARTNER
              ],
              ['event_groups.show']
            )
          "
          [link]="['/event-groups/view']"
          [params]="{ id: dataItem.id }"
        >
        </app-preview-button>

        <app-edit-button
          *ngIf="accessService.hasAccess([UserRoleType.LEAD_GENERATION], ['event_groups.show'])"
          (click)="edit(dataItem)"
        >
        </app-edit-button>

        <app-seo-button
          *ngIf="accessService.hasAccess([UserRoleType.IT, UserRoleType.MARKETING], ['event_groups.translations'])"
          (click)="editSeo(dataItem)"
        ></app-seo-button>

        <app-media-library-button
          *ngIf="accessService.hasAccess([UserRoleType.IT, UserRoleType.MARKETING], ['media.index'])"
          [ngbTooltip]="'EVENT_GROUPS.EVENT_GROUPS_LIST.UPLOAD_IMAGES' | translate"
          container="body"
          [collectionName]="'gallery'"
          [acceptType]="MediaLibraryAcceptTypes.IMAGES"
          [modelId]="dataItem.id"
          [modelType]="LaravelModels.EVENTGROUP"
        >
        </app-media-library-button>

        <app-media-library-button
          *ngIf="accessService.hasAccess([UserRoleType.IT, UserRoleType.MARKETING], ['media.index'])"
          [ngbTooltip]="'EVENT_GROUPS.EVENT_GROUPS_LIST.UPLOAD_WIDE_BACKGROUND' | translate"
          container="body"
          [collectionName]="'wide-background'"
          [acceptType]="MediaLibraryAcceptTypes.IMAGES"
          [modelId]="dataItem.id"
          [modelType]="LaravelModels.EVENTGROUP"
          [localesFeature]="true"
        >
        </app-media-library-button>

        <app-delete-button
          *ngIf="accessService.hasAccess([UserRoleType.LEAD_GENERATION], ['event_groups.destroy'])"
          [swal]="{}"
          (confirm)="delete(dataItem)"
        >
        </app-delete-button>

        <app-links-compact-translates [data]="dataItem"> </app-links-compact-translates>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-input></kendo-pager-input>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
      <app-kendo-grid-refresh-button (click)="loadData(state)"></app-kendo-grid-refresh-button>
      <button type="button" class="btn kendo-export-btn" [disabled]="grid.loading" kendoGridExcelCommand>
        {{ 'EXPORT_TO_EXCEL' | translate }}
      </button>
    </ng-template>

    <kendo-grid-excel></kendo-grid-excel>
  </kendo-grid>
</div>
